import { applyMiddleware, compose, createStore } from 'redux';
import Config from 'config';

// Reducers
import makeRootReducer from './reducers';

// Middleware
import thunk from 'redux-thunk';
import DataService from '@sift/resift/redux/DataService';
import MockDataService, { withoutMockedActions } from '@sift/resift/redux/MockDataService';
import DataServiceActionHandlers, { unauthorizedHandler } from './dataServiceActionHandlers';
import mockDataServiceHandlers from './dataServiceActionHandlers/mockHandlers.js';
import dataServiceMiddleware from './dataServiceMiddleware';

export default (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const SiftDataService = new DataService(
    withoutMockedActions(DataServiceActionHandlers, mockDataServiceHandlers),
    unauthorizedHandler,
  );

  const mockDataService = new MockDataService(mockDataServiceHandlers);

  // TODO: add if process.env.DEVELOPMENT

  const middleware = [
    thunk,
    dataServiceMiddleware,
    SiftDataService.middleware,
    mockDataService.middleware,
  ];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];

  let composeEnhancers = compose;

  if (Config.ENV === 'development') {
    const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    if (typeof composeWithDevToolsExtension === 'function') {
      composeEnhancers = composeWithDevToolsExtension;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers),
  );
  store.asyncReducers = {};

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  return store;
};
